import {
  type CommonCustomErrorResponse,
  type CommonSubmitSurveyAnswerRequest,
  type ProblemDetails,
  type WebV1SurveysCreateData,
  Surveys
} from '@credit-web/services/product-journey-girar'
import { type AllServicesQueryParams, type TransformTypesToCamelCase } from '@credit-web/services/types'

// eslint-disable-next-line no-restricted-imports
import { type UseMutationRequestOptions, useMutationRequest } from '~/ui/hooks/utils/service/use-query-request'

type UseSurveysAnswersCreateResponse = TransformTypesToCamelCase<WebV1SurveysCreateData>
export type UseSurveysRequestVariables = {
  answers: TransformTypesToCamelCase<CommonSubmitSurveyAnswerRequest>
  query: AllServicesQueryParams
}

/**
 * @tags hook
 * @name useSurveysAnswersCreate
 * @summary Answers survey
 * @request POST:/api/web/v1/surveys
 * @secure
 * @response `200` `WebV1SurveysCreateData` OK
 * @response `204` `void` No Content
 * @response `400` `CommonCustomErrorResponse` Bad Request
 * @response `403` `ProblemDetails` Forbidden
 */
export const useSurveysAnswersCreate = (
  mutationOptions?: UseMutationRequestOptions<
    UseSurveysAnswersCreateResponse,
    CommonCustomErrorResponse | ProblemDetails,
    false,
    UseSurveysRequestVariables
  >
) => {
  return useMutationRequest<
    UseSurveysAnswersCreateResponse,
    CommonCustomErrorResponse | ProblemDetails,
    false,
    UseSurveysRequestVariables
  >(
    ['webV1SurveysCreate'],
    ({ answers, query }) =>
      Surveys.webV1SurveysCreate(
        // force the cast here, but the payload will be transformed to snake_case at http-client
        answers as unknown as CommonSubmitSurveyAnswerRequest,
        { query }
      ),
    {
      ...mutationOptions
    }
  )
}
